module.exports = __webpack_public_path__ + "img/50_BF28_fear_of_flying.1209a330.jpg";